// Device-cached free usage quota for guests (not signed in).
// Up to FREE_DAILY_LIMIT productive barcode generations per day, tracked in
// localStorage (the "device cache"). Resets daily. Signed-in users are unlimited.

const KEY = 'bcs-free-usage';
export const FREE_DAILY_LIMIT = 5;

function today() {
  // Local date (YYYY-MM-DD) so the quota resets at the user's local midnight.
  const d = new Date();
  const off = d.getTimezoneOffset();
  return new Date(d.getTime() - off * 60000).toISOString().slice(0, 10);
}

export function getFreeUsage() {
  try {
    const raw = localStorage.getItem(KEY);
    if (raw) {
      const o = JSON.parse(raw);
      if (o && o.date === today() && typeof o.count === 'number') return o;
    }
  } catch (e) { console.error('freeQuota: non-critical storage error:', e); }
  return { date: today(), count: 0 };
}

export function freeRemaining() {
  return Math.max(0, FREE_DAILY_LIMIT - getFreeUsage().count);
}

// Consume one free generation and return the remaining count.
export function consumeFree() {
  const u = getFreeUsage();
  const next = { date: today(), count: u.count + 1 };
  try { localStorage.setItem(KEY, JSON.stringify(next)); } catch (e) { console.error('freeQuota: non-critical storage error:', e); }
  return Math.max(0, FREE_DAILY_LIMIT - next.count);
}
